/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The ListingStatus enum represents the possible statuses of a listing.
 */
export enum ListingStatus {
    ACTIVE = 'active',
    CLOSED = 'closed',
    ALL = 'all',
}
